
import OtherProjects from './OtherProjects';
import ProjectBanner from './ProjectBanner';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BaseUrl } from '../../helper/BaseUrl';

export default function ProjectDetail({ initialData }) {
    const [allData, setAllData] = useState(initialData?.listpage || []);
    const fetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/projects`, {
                method: 'GET',
            });
            const result = await response.json();
            if (result.projects === false) {
                throw new Error(`API error: ${result.message}`);
            }
            setAllData(result.projects);
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    };

    useEffect(() => {
        fetcher();
    }, [])

    if (!allData) {
        return null;
    }

    return (
        <>
            <ProjectBanner initialData={initialData?.detailpage} />
            <OtherProjects allData={allData} extraClass="other-projects-wrap" />
        </>
    )
}
